import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from 'app/app.component';

import { AppRouting } from './app.routing';
import { WorkInProgressModule } from './back-office/shared/components/errors/work-in-progress/work-in-progress.module';
import { LoaderModule } from './shared/components/loader/loader.module';
import { CoreModule } from './shared/core.module';
import { B2CPolicies, MSALConfig } from './shared/models/auth-config.model';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/auth/auth-interceptor';
import { CanActivatAuthGuard } from './shared/auth/can-activate-guard.service';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localePy from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import { LocaleProvider } from './locale.provider';

registerLocaleData(localeIt, 'it');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localePy, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRouting,
    BrowserModule,
    BrowserAnimationsModule,
    WorkInProgressModule,
    CoreModule.forRoot(),
    TranslateModule.forRoot(),
    LoaderModule,
    MsalModule.forRoot(
      new PublicClientApplication(MSALConfig()),
      {
        // The routing guard configuration.
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: [B2CPolicies().scope]
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([])
      }
    ),
  ],
  providers: [
    LocaleProvider,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    MsalGuard,
    CanActivatAuthGuard,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }

